import React, { useState } from 'react';
import { Dispatch } from '../../../../store/store';
import { connect } from 'react-redux';
import { useNavigate, generatePath } from 'react-router-dom';
import { initialValues, validationSchema, editRecipeFullPath } from '../../constants';
import { preHeatRecipeInitialValues, preHeatRecipeValidationSchema } from '../../../PreHeatRecipes/constants';
import { RecipeForm } from '../../Components/RecipeForm';
import { IRecipeEditable, IPreHeatRecipeEditable } from '../../../../types/recipes-types';
import { PreHeatRecipeForm } from '../../../PreHeatRecipes/Components/PreHeatRecipeForm';
import CycleSettings from '../../../../enums/cycle-setting.enum';
import { useTranslation } from 'react-i18next';
type ComponentProps = ReturnType<typeof mapDispatch>;

const RecipeCreate: React.FC<ComponentProps> = ({ createRecipe }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedForm, setSelectedForm] = useState<CycleSettings.PostWeld | CycleSettings.PreHeat>(
    CycleSettings.PostWeld,
  );

  const onSubmitHandler = async (data: IRecipeEditable) => {
    const createdRecipe = await createRecipe(data);
    if (createdRecipe) {
      const path = generatePath(editRecipeFullPath, { id: createdRecipe.id });
      navigate(path);
    }
  };

  const onPreHeatSubmitHandler = async (data: IPreHeatRecipeEditable) => {
    const createdPreHeatRecipe = await createRecipe(data);
    if (createdPreHeatRecipe) {
      const path = generatePath(editRecipeFullPath, { id: createdPreHeatRecipe.id });
      navigate(path);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="recipeType"
            value="post-weld"
            checked={selectedForm === CycleSettings.PostWeld}
            onChange={(e) => setSelectedForm(e.target.value as CycleSettings.PostWeld)}
            className="h-4 w-4"
          />
          <span>Post Weld</span>
        </label>
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="recipeType"
            value="pre-heat"
            checked={selectedForm === CycleSettings.PreHeat}
            onChange={(e) => setSelectedForm(e.target.value as CycleSettings.PreHeat)}
            className="h-4 w-4"
          />
          <span>Pre Heat</span>
        </label>
      </div>

      {selectedForm === CycleSettings.PostWeld ? (
        <RecipeForm
          initialValues={initialValues}
          validationSchema={validationSchema}
          submitButtonName={t('buttons.create')}
          formName={t('labels.createRecipe')}
          onSubmit={onSubmitHandler}
          enableTemperatureUnitSwitcher
        />
      ) : (
        <PreHeatRecipeForm
          initialValues={preHeatRecipeInitialValues}
          validationSchema={preHeatRecipeValidationSchema}
          submitButtonName={t('buttons.create')}
          formName={t('labels.createRecipe')}
          onSubmit={onPreHeatSubmitHandler}
          enableTemperatureUnitSwitcher
        />
      )}
    </div>
  );
};

const mapDispatch = (dispatch: Dispatch) => ({
  createRecipe: dispatch.recipes.createRecipe,
});

export default connect(null, mapDispatch)(RecipeCreate);
